import { concat, sum } from 'ramda';
import { inventoryManagementApi } from '../inventoryManagementApi';

const getUrl = concat('dashboard/');

const dashboardEndpoints = inventoryManagementApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getAllocationGroups: query({
      providesTags: ['Inventory Projections Filters'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-allocation-groups'),
      }),
    }),
    getBillsOfLading: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-bills-of-lading-reports-all-products'),
      }),
    }),
    getBillsOfLadingInventoryOwner: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-bills-of-lading-inventory-owner-all-products'),
      }),
    }),
    getBookingHistory: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-booking-history-reports-all-products'),
      }),
    }),
    getCurrentInventoryDetails: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-current-inventory-details-reports-all-products'),
      }),
    }),
    getCurrentInventorySummary: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-inventory-summary-reports-all-products'),
      }),
      transformResponse: response =>
        response.map(summary => ({
          ...summary,
          totalVol: sum([
            summary.availableVol,
            summary.availableReservedVol,
            summary.inTransitVol,
            summary.inTransitReservedVol,
          ]),
        })),
    }),
    getDailyProjection: query({
      providesTags: ['Daily Projection'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-daily-projection-details'),
      }),
    }),
    getHistoricalInventory: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-historical-inventory-reports-all-products'),
      }),
    }),
    getInventoryDailyProjections: query({
      providesTags: ['Inventory Projections'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-inventory-daily-projections'),
      }),
    }),
    getInventoryProjections: query({
      providesTags: ['Inventory Projection'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-inventory-projections'),
      }),
    }),
    getInventoryProjectionsReport: query({
      providesTags: ['Reports'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-inventory-projections-report-all-products'),
      }),
    }),
    getProductGroups: query({
      providesTags: ['Inventory Projections Filters'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-groups'),
      }),
    }),
  }),
});

export const {
  useGetAllocationGroupsQuery,
  useGetBillsOfLadingQuery,
  useGetBillsOfLadingInventoryOwnerQuery,
  useGetBookingHistoryQuery,
  useGetCurrentInventoryDetailsQuery,
  useGetCurrentInventorySummaryQuery,
  useGetDailyProjectionQuery,
  useGetHistoricalInventoryQuery,
  useGetInventoryProjectionsQuery,
  useGetInventoryProjectionsReportQuery,
  useGetInventoryDailyProjectionsQuery,
  useGetProductGroupsQuery,
} = dashboardEndpoints;
